import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3046aa63&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3046aa63&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3046aa63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3046aa63')) {
      api.createRecord('3046aa63', component.options)
    } else {
      api.reload('3046aa63', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3046aa63&scoped=true", function () {
      api.rerender('3046aa63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/oldAgeEducation/index.vue"
export default component.exports